
import './App.css';
import {MainContent} from "./components/content"

function App() {

  return (
    <div className="App">
     <MainContent/>
 
    </div>
  );
}

export default App;
